<template>
  <div class="nav-left-header">
    <!-- <div class="nav-left-shopinfo">
      <img class="shopimg" :src="shop.shopLogo" alt="" />
      <div class="shop-info">
        <p class="shop-name">{{ shop.shopName }}</p>
        <el-tag :type="shop.isVerified ? 'success' : 'danger'">{{
          shop.isVerified ? "已认证" : "未认证"
        }}</el-tag>
        <p class="state" :class="shop.state ? 'certified' : 'uncertified'"></p>
      </div>
    </div> -->
    <el-select
      v-if="
        isMaster && shopList.length && shop.edcShopType != 8 && shop.edcShopType != 14
      "
      v-model="currentShop"
      placeholder="请选择"
    >
      <div
        slot="prefix"
        class="shop-type current"
        :class="{ ismaster: masterShopStoreId == currentShop }"
      >
        <span> {{ masterShopStoreId == currentShop ? "总店" : "分店" }}</span>
        <span>{{ shop.isVerified ? "已认证" : "未认证" }}</span>
      </div>
      <el-option
        v-for="item in shopList"
        :key="item.shopStoreId"
        :label="item.shopName"
        :value="item.shopStoreId"
      >
        <span class="shop-type" :class="{ ismaster: item.isMaster }">{{
          item.isMaster ? "总店" : "分店"
        }}</span
        >{{ item.shopName }}
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { getStoreList, getUserInfo } from "@/api";
import { mapState, mapActions } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      shopList: [],
      currentShop: "",
      masterShopStoreId: "",
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
  },
  watch: {
    currentShop(val, oldval) {
      console.log(oldval);
      this.updateShopStoreId(val);
      if (oldval) {
        this.$router.replace("/");
        location.reload();
      }
    },
  },
  created() {
    if (localStorage.sessionId) {
      getUserInfo().then((res) => {
        if (res.code == 1) {
          localStorage.userType = res.data.userType;
        }
      });
    }
  },
  mounted() {
    this.getStoreList();
    this.currentShop = Number(localStorage.shopStoreId);
  },
  methods: {
    ...mapActions(["updateShopStoreId"]),
    getStoreList() {
      getStoreList({
        shopStoreId: "",
        row: 9999,
      }).then((res) => {
        if (res.code == 1) {
          this.shopList = res.data;
          res.data.forEach((val) => {
            if (val.isMaster) {
              this.masterShopStoreId = val.shopStoreId;
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less">
.nav-left-header {
  text-align: center;
  .nav-left-shopinfo {
    display: flex;
    padding: 40px 20px 40px 30px;
    .shopimg {
      width: 36px;
      min-width: 36px;
      height: 36px;
      border-radius: 2px;
      object-fit: cover;
    }
    .shop-info {
      flex: 1;
      padding-left: 10px;
      p {
        font-size: 12px;
        line-height: 16px;
      }
      .shop-name {
        width: 84px;
        color: #333333;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .el-tag {
        height: 17px;
        line-height: 15px;
        padding: 0 4px;
      }
    }
  }
  .el-select {
    width: 100%;
    border-radius: 7.92px;
    background: linear-gradient(
      90deg,
      rgba(255, 217, 212, 1) 0%,
      rgba(255, 250, 245, 1) 100%
    );
    // margin: 10px auto;
    .el-input {
      .el-input__inner {
        padding-left: 85px;
        background-color: transparent;
        border: none;
      }
      .el-select__caret {
        color: rgba(255, 70, 47, 1);
      }
    }
  }
}
.shop-type {
  display: inline-block;
  // border-color: #43a0ff;
  // color: #43a0ff;
  // border: 1px solid;
  font-size: 12px;
  line-height: 12px;
  margin-right: 6px;
  border-radius: 3px;
  vertical-align: middle;
  overflow: hidden;
  &.ismaster {
    border-color: #f56c6c;
    color: #f56c6c;
  }
  &.current {
    position: relative;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background: #43a0ff;
    color: #fff;
    &.ismaster {
      background: #f56c6c;
    }
  }
  span {
    display: inline-block;
    padding: 4px;
    &:nth-of-type(2) {
      background-color: #fff;
      color: #f56c6c;
    }
  }
}
</style>
